import { RefObject } from "react";
import { AddMore } from "../../../../svg/add-more";
import { DocUploadIcon } from "../../../../svg/doc-upload-icon";
import NewFileUploaderCard from "../../../newFileUploader/newFileUploader";

interface FileUploadSectionProps {
  showDragDropUpload?: boolean;
  fileNames: string[];
  progress: number;
  isUploading: boolean;
  fileInputRef: RefObject<HTMLInputElement>;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFileDelete: (index: number) => void;
  onUploadClick: () => void;
  onDeleteClick: () => void;
}

const FileUploadSection = ({
  showDragDropUpload,
  fileNames,
  progress,
  isUploading,
  fileInputRef,
  onFileChange,
  onFileDelete,
  onUploadClick,
  onDeleteClick,
}: FileUploadSectionProps) => {
  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <div className="documents-modal--container flex flex-col gap-3">
        <div
          className="documents-modal--add-more mt-2 flex items-center gap-1 hover:cursor-pointer"
          onClick={handleClick}
        >
          {showDragDropUpload ? (
            <div className="flex h-32 w-full flex-col items-center justify-center gap-1 rounded-lg border-2 border-dashed border-primaryGray-15 p-2">
              <DocUploadIcon />
              <div className="main-text text-sm">
                Drag and drop or{" "}
                <span className="text-tertiaryBlue-4">click here</span> to
                upload
              </div>
            </div>
          ) : (
            <div className="flex flex-row items-center gap-1">
              <AddMore />
              <div className="documents-modal--add-more--text text-h12 font-semibold text-tertiaryBlue-4">
                Add More
              </div>
            </div>
          )}
          <input
            type="file"
            ref={fileInputRef}
            multiple
            className="hidden"
            onChange={onFileChange}
            accept=".pdf"
            onClick={() => onUploadClick()}
          />
        </div>
        {fileNames.map((docName, index) => (
          <NewFileUploaderCard
            key={`${docName}-${index}`}
            fileName={docName}
            progress={progress}
            isUploading={isUploading}
            handleDelete={() => {
              onFileDelete(index);
              onDeleteClick();
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default FileUploadSection;
